import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Icon, message, Checkbox, InputNumber, DatePicker, Collapse, Tooltip } from 'antd';
import { Doughnut } from 'react-chartjs-2';
import { getPropEventsForEvent, makePropEvent } from "../../api-calls/events"
import { makeEvent as makeContractEvent } from "../../contract/Events"
import Modal from 'react-modal'
import { duration } from 'moment';
import AvailablePropBets from "../layoutComponents/AvailablePropBets"

@observer(["AuthStore", "ViewStore", "eventStore", "AdminStore", "WagerStore", "BetSlipStore", "web3Store", "CustomRouter", "UserStore", "TeamStore", "CategoriesStore"])

export default class PropBets extends Component {

    constructor(props) {
        super(props);

        this.state = {
            finalRender: <div />,
            loaded: false,
            loading: true,
            modalVisible: false,
            newBetTitle: "",
            newBetOptionOne: "",
            newBetOptionTwo: "",
            optionOneBytesId: "",
            optionTwoBytesId: "",
            drawBytesId: "0x6472617700000000000000000000000000",
            newBetDuration: 0,
            drawPossible: false,
            officialStart: this.props.originalEvent.startTime,
            makerBond: 10000
        }
        this.renderBetsForOneType = this.renderBetsForOneType.bind(this);
        this.renderBetsForOneType = this.renderBetsForOneType.bind(this);
        this.openModal = this.openModal.bind(this);
        this.handleModalOk = this.handleModalOk.bind(this);
        this.handleModalCancel = this.handleModalCancel.bind(this);
        this.handleNewBetTitleChange = this.handleNewBetTitleChange.bind(this);
        this.handleNewBetOptionOneChange = this.handleNewBetOptionOneChange.bind(this);
        this.handleNewBetOptionTwoChange = this.handleNewBetOptionTwoChange.bind(this);
        this.onDrawPossibleChange = this.onDrawPossibleChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleNewBetDuration = this.handleNewBetDuration.bind(this);
        this.addPropWagerToBetSlip = this.addPropWagerToBetSlip.bind(this);



    }

    componentDidMount() {
        if (!this.state.loaded && this.state.loading) {
            this.setState({ finalRender: <Icon type="loading" /> })
        }
        this.renderPropBetTypes();
    }

    renderPropBetTypes() {
        let finalArray = [];
        let self = this;

        getPropEventsForEvent(this.props.eventId).then((betTypes) => {
            self.setState({ propBetTypes: betTypes });
            betTypes.forEach(betType => {
                finalArray.push(
                    self.renderBetsForOneType(betType))
            });
            if (finalArray.length > 0) {
                self.setState({ finalRender: finalArray })
            } else {
                self.setState({
                    finalRender: <div className="single-event-page-card-wagers-title"></div>, //no prop bets found
                    loaded: true,
                    loading: false
                });
            }
        }).catch((e) => {
            message.error(e);
            self.setState({
                finalRender: <div className="single-event-page-card-wagers-title"></div>, //no prop bets found
                loaded: true,
                loading: false
            });
        })


    }
    renderTeamOneWagers(propEvent) {
        return <AvailablePropBets propEvent={propEvent} teamBetsAreAgainst={1} />

    }

    renderTeamTwoWagers(propEvent) {
        return <AvailablePropBets propEvent={propEvent} teamBetsAreAgainst={2} />

    }
    roundNum(value, precision) {
        var multiplier = Math.pow(10, precision || 0);
        return Math.round(value * multiplier) / multiplier;
    }


    renderBetsForOneType(betType) {
        const { WagerStore } = this.props;
        const Panel = Collapse.Panel;

        const customPanelStyle = {
            background: '#11324a',
            borderRadius: 4,
            marginBottom: 10,
            borderBottom: "1px solid rgba(255,255,255,0)",
            overflow: 'hidden',
        };
        let teamOneWagersComponent = <div style={{ textAlign: 'center', marginTop: '25px', fontSize: '26px' }}><Icon type="loading" /></div>;
        let teamTwoWagersComponent = <div style={{ textAlign: 'center', marginTop: '25px', fontSize: '26px' }}><Icon type="loading" /></div>;

        if (!WagerStore.loading) {
            teamOneWagersComponent = this.renderTeamOneWagers(betType);
            teamTwoWagersComponent = this.renderTeamTwoWagers(betType);

        }

        let teamOneGraphData;
        let teamTwoGraphData;
        console.log("BET TYPE : " + JSON.stringify(betType));
        let amountBetForOne;
        let amountBetForTwo;
        if (betType.amountBetForTeam.length > 0) {
            amountBetForOne = betType.amountBetForTeam[0];
            amountBetForTwo = betType.amountBetForTeam[1];
        } else {
            amountBetForOne = 0;
            amountBetForTwo = 0;
        }
        let betsForTeamOne;
        let betsForTeamTwo;
        if (betType.betsForTeam.length > 0) {
            betsForTeamOne = betType.betsForTeam[0];
            betsForTeamTwo = betType.betsForTeam[1];
        } else {
            betsForTeamOne = 0;
            betsForTeamTwo = 0;
        }
        let teamOneColor = '#5b616b';
        let teamTwoColor = '#3296f7';

        if (betsForTeamOne == 0 && betsForTeamTwo == 0) {
            teamOneGraphData = 50 / 100;
            teamTwoGraphData = 50 / 100;
        } else if (betsForTeamOne > 0 && betsForTeamTwo == 0) {
            teamOneGraphData = 1;
            teamTwoGraphData = 0;
        } else if (betsForTeamOne == 0 && betsForTeamTwo > 0) {
            teamTwoGraphData = 1;
            teamOneGraphData = 0;
        } else {
            teamOneGraphData = amountBetForOne / (amountBetForOne + amountBetForTwo);
            teamTwoGraphData = amountBetForTwo / (amountBetForOne + amountBetForTwo);
        }
        let gridTemplateColumnsPercentage = String(teamOneGraphData * 100) + "%" + String(teamTwoGraphData * 100) + "%";
        let betsForOneDonutData = 0;
        let betsForTwoDonutData = 0;
        if (betsForTeamOne == 0 && betsForTeamTwo == 0) {
            betsForOneDonutData = 1;
            betsForTwoDonutData = 1;
        } else {
            betsForOneDonutData = amountBetForOne;
            betsForTwoDonutData = amountBetForTwo;
        }
        const DoughnutData = {
            labels: [
                betType.teams[1].toUpperCase(),
                betType.teams[0].toUpperCase(),
            ],
            datasets: [{
                data: [betsForTwoDonutData, betsForOneDonutData],
                // backgroundColor: [
                //     teamTwoColor,
                //     teamOneColor
                // ],
                // hoverBackgroundColor: [
                //     teamTwoColor,
                //     teamOneColor,
                // ], 
                backgroundColor: [
                    '#5b616b',
                    '#3296f7'

                ],
                hoverBackgroundColor: [
                    '#5b616b',
                    '#3296f7'

                ],
                // backgroundColor: [
                //     this.state.teamTwoColor,
                //     this.state.teamOneColor,
                // ],
                // hoverBackgroundColor: [
                //     this.state.teamTwoColor,
                //     this.state.teamOneColor,
                // ],
                borderColor: [
                    'rgba(255, 255, 255, 0)',
                    'rgba(255, 255, 255, 0)',
                ],
            }]
        };


        return <div>
            <br />
            <Collapse bordered={false} >
                {/* defaultActiveKey={['1']} */}

                <Panel default="closed" header={<div className="single-event-page-card-wagers-title">

                    <div style={{ marginLeft: "3%" }} className="single-event-page-card-wagers-title">{betType.propTitle} - {this.roundNum(teamOneGraphData * 100)}% {betType.teams[0]}</div>

                    <br />
                    <div style={{ width: "96%" }} >
                        <div className="graph-lines-wrapper">
                            {teamOneGraphData == 0 || teamTwoGraphData == 0 ?
                                (teamOneGraphData > 0 ? <div className="graph-lines">
                                    <svg className="firstLine" height={10} width={"50%"}>
                                        <line x1='100%' y1={5} x2={0} y2={5} style={{ stroke: teamOneColor, strokeWidth: 6 }} />
                                    </svg>
                                    <svg className="secondLine" height={10} width={"50%"}>
                                        <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: teamOneColor, strokeWidth: 6 }} />
                                    </svg>
                                </div> :
                                    <div className="graph-lines">
                                        <svg className="firstLine" height={10} width={"50%"}>
                                            <line x1='100%' y1={5} x2={0} y2={5} style={{ stroke: teamTwoColor, strokeWidth: 6 }} />
                                        </svg>
                                        <svg className="secondLine" height={10} width={"50%"}>
                                            <line x1={0} y1={5} x2='100%' y2={5} style={{ stroke: teamTwoColor, strokeWidth: 6 }} />
                                        </svg>
                                    </div>
                                ) :
                                <div className="graph-lines">
                                    <div style={{ display: 'grid', gridTemplateColumns: gridTemplateColumnsPercentage, height: '7px' }}>
                                        <div style={{ background: teamOneColor }} ></div>
                                        <div style={{ background: teamTwoColor }} ></div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>} key="1" style={customPanelStyle}>


                    <div className="single-event-page-card-wagers-grid">
                        {/* <Doughnut
                        legend={null}
                        width={11}
                        options={{
                            maintainAspectRatio: false
                        }}
                        height={5}
                        data={DoughnutData}
                    />       */}
                        <div className="single-event-page-card-team-wagers">
                            {/* <div className="single-event-page-card-team-wagers-title">
                    
                       
                    </div> */}  <div className="single-event-page-cards-bet-options">
                                <Tooltip title={<span>Create new bet.</span>} >
                                    <button onClick={() => this.addPropWagerToBetSlip(1, betType)} className="single-event-page-cards-options-teamone">
                                        <span className="single-event-page-cards-bet-options-title">{betType.teams[0]}</span>
                                        {/* <div className="single-event-page-cards-bets-amount">{amountBetForTwo} ETH BET</div> */}
                                    </button>
                                </Tooltip>
                            </div>
                            {/* <div className="single-event-page-card-team-wagers-sort-options">
                    <div className="single-event-page-card-team-wagers-sort-options-sort">
                        <span className="single-event-page-card-team-wagers-sort-options-sort-title">Sort by:</span>
                        <button onClick={() => this.onTeamTwoWagerSortingMenuClick({ key: 1 })} className={this.state.sortTeamTwoWagersByValueAscending || this.state.sortTeamTwoWagersByValueDescending ? "custom-btn" : "custom-btn-primary"} style={{ fontSize: '10px', padding: '0px 5px 0px 5px', border: 'none' }}>
                            Potential Win {this.state.sortTeamTwoWagersByValueAscending ? <Icon type="up" /> : null}
                            {this.state.sortTeamTwoWagersByValueDescending ? <Icon type="down" /> : null}
                        </button>
                        <button onClick={() => this.onTeamTwoWagerSortingMenuClick({ key: 2 })} className={this.state.sortTeamTwoWagersByOddsAscending || this.state.sortTeamTwoWagersByOddsDescending ? "custom-btn" : "custom-btn-primary"} style={{ fontSize: '10px', padding: '0px 5px 0px 5px', border: 'none' }}>
                            Odds {this.state.sortTeamTwoWagersByOddsAscending ? <Icon type="up" /> : null}
                            {this.state.sortTeamTwoWagersByOddsDescending ? <Icon type="down" /> : null}
                        </button>
                        <button onClick={() => this.onTeamTwoWagerSortingMenuClick({ key: 3 })} className={this.state.sortTeamTwoWagersByPotentialWinAscending || this.state.sortTeamTwoWagersByPotentialWinDescending ? "custom-btn" : "custom-btn-primary"} style={{ fontSize: '10px', padding: '0px 5px 0px 5px', border: 'none' }}>
                            To Take {this.state.sortTeamTwoWagersByPotentialWinAscending ? <Icon type="up" /> : null}
                            {this.state.sortTeamTwoWagersByPotentialWinDescending ? <Icon type="down" /> : null}
                        </button>
                    </div>
                    <div className="single-event-page-card-team-wagers-sort-options-reset">
                        {
                            this.state.sortTeamTwoWagersByValueAscending || this.state.sortTeamTwoWagersByValueDescending || this.state.sortTeamTwoWagersByOddsAscending ||
                                this.state.sortTeamTwoWagersByOddsDescending || this.state.sortTeamTwoWagersByPotentialWinAscending ||
                                this.state.sortTeamTwoWagersByPotentialWinDescending ?
                                <button onClick={this.resetTeamTwoWagerSort} className="custom-btn-primary" style={{ fontSize: '10px', padding: '0px 5px 0px 5px', border: 'none' }}>Reset</button>
                                :
                                null
                        }
                    </div>
                </div> */}
                            <div className="single-event-page-card-wagers-component">
                                {teamTwoWagersComponent}
                            </div>

                        </div>
                        <div className="single-event-page-card-team-wagers">
                            {/* <div className="single-event-page-card-team-wagers-title">{betType.teams[1]}
                        <button className="custom-btn-primary"
                            style={{ fontSize: '10px', padding: '0px 5px 0px 5px', border: 'solid', borderColor: "white", borderWidth: "1px" }}>Create Bet</button>
                    </div> */}

                            <div className="single-event-page-cards-bet-options">
                                <Tooltip title={<span>Create new bet.</span>} >
                                    {/* <a href="https://mevu.bet/fees">Full Fee Breakdown</a></span>}> */}


                                    <button onClick={() => this.addPropWagerToBetSlip(2, betType)} className="single-event-page-cards-options-teamtwo">
                                        <span className="single-event-page-cards-bet-options-title">{betType.teams[1]}</span>
                                        {/* <div className="single-event-page-cards-bets-amount">{amountBetForTwo} ETH BET</div> */}
                                    </button>
                                </Tooltip>
                            </div>
                            {/* <div className="single-event-page-card-team-wagers-sort-options">
                    <div className="single-event-page-card-team-wagers-sort-options-sort">
                        <span className="single-event-page-card-team-wagers-sort-options-sort-title">Sort by:</span>
                        <button onClick={() => this.onTeamOneWagerSortingMenuClick({ key: 1 })} className={this.state.sortTeamOneWagersByValueAscending || this.state.sortTeamOneWagersByValueDescending ? "custom-btn" : "custom-btn-primary"} style={{ fontSize: '10px', padding: '0px 5px 0px 5px', border: 'none' }}>
                            Potential Win {this.state.sortTeamOneWagersByValueAscending ? <Icon type="up" /> : null}
                            {this.state.sortTeamOneWagersByValueDescending ? <Icon type="down" /> : null}
                        </button>
                        <button onClick={() => this.onTeamOneWagerSortingMenuClick({ key: 2 })} className={this.state.sortTeamOneWagersByOddsAscending || this.state.sortTeamOneWagersByOddsDescending ? "custom-btn" : "custom-btn-primary"} style={{ fontSize: '10px', padding: '0px 5px 0px 5px', border: 'none' }}>
                            Odds {this.state.sortTeamOneWagersByOddsAscending ? <Icon type="up" /> : null}
                            {this.state.sortTeamOneWagersByOddsDescending ? <Icon type="down" /> : null}
                        </button>
                        <button onClick={() => this.onTeamOneWagerSortingMenuClick({ key: 3 })} className={this.state.sortTeamOneWagersByPotentialWinAscending || this.state.sortTeamOneWagersByPotentialWinDescending ? "custom-btn" : "custom-btn-primary"} style={{ fontSize: '10px', padding: '0px 5px 0px 5px', border: 'none' }}>
                            To Take {this.state.sortTeamOneWagersByPotentialWinAscending ? <Icon type="up" /> : null}
                            {this.state.sortTeamOneWagersByPotentialWinDescending ? <Icon type="down" /> : null}
                        </button>
                    </div>
                    <div className="single-event-page-card-team-wagers-sort-options-reset">
                        {
                            this.state.sortTeamOneWagersByValueAscending || this.state.sortTeamOneWagersByValueDescending || this.state.sortTeamOneWagersByOddsAscending ||
                                this.state.sortTeamOneWagersByOddsDescending || this.state.sortTeamOneWagersByPotentialWinAscending ||
                                this.state.sortTeamOneWagersByPotentialWinDescending ?
                                <button onClick={this.resetTeamOneWagerSort} className="custom-btn-primary" style={{ fontSize: '10px', padding: '0px 5px 0px 5px', border: 'none' }}>Reset</button>
                                :
                                null
                        }
                    </div>
                </div> */}
                            <div className="single-event-page-card-wagers-component">
                                {teamOneWagersComponent}
                            </div>
                        </div>
                    </div>
                </Panel>
            </Collapse>
        </div>


    }

    handleModalCancel() {
        this.setState({ modalVisible: false });

    }

    handleModalOk() {
        const { originalEvent, web3Store, AuthStore, UserStore } = this.props;
        const authToken = AuthStore.userAuth.auth.accessToken;
        const eventBytes32Id = web3Store.web3.utils.sha3(this.state.newBetOptionOne + this.state.newBetOptionTwo + (+Date.now()));
        let options = [];
        let drawPossible = this.state.drawPossible;
        let startTime = Number(this.state.officialStart);
        let duration = Number(this.state.newBetDuration);
        let makerBond = this.state.makerBond;
        let maker = UserStore.user._id;
        const propTitle = this.state.newBetTitle;
        options.push(this.state.newBetOptionOne);
        options.push(this.state.newBetOptionTwo);

        let self = this;
        let contractTeams;
        if (drawPossible) {
            contractTeams = [this.state.drawBytesId, this.state.optionOneBytesId, this.state.optionTwoBytesId];
        } else {
            contractTeams = [this.state.optionOneBytesId, this.state.optionTwoBytesId];
        }


        if (this.state.newBetTitle == "") {
            message.warning("Title cannot be blank!");
        } else if (this.state.newBetOptionOne == "") {
            message.warning("Option one cannot be blank!");
        } else if (this.state.newBetOptionTwo == "") {
            message.warning("Option two cannot be blank!");
        } else if (this.state.newBetDuration <= 0) {
            message.warning("Duration must be greater than 0");
        } else {
            // submit new prop type

            makeContractEvent(eventBytes32Id, startTime, duration, contractTeams, false).then(
                function (result) {
                    if (String(result).includes('User denied transaction signature')) {
                        message.warning("Metamask transaction denied! No event made.");
                    } else {
                        makePropEvent(
                            authToken,
                            eventBytes32Id,
                            options,
                            drawPossible,
                            startTime,
                            duration,
                            makerBond,
                            maker,
                            false,
                            originalEvent.categoryId,
                            originalEvent.leagueId,
                            originalEvent.teamOneColor,
                            originalEvent.teamTwoColor,
                            true,
                            originalEvent._id,
                            propTitle
                        ).then((result) => {
                            message.info("New prop type submit!");
                            self.setState({ modalVisible: false });

                        }).catch((e) => {
                            console.log("error: " + String(e));
                            self.setState({ modalVisible: false });
                        })
                    }
                });

        }

    }

    addPropWagerToBetSlip(teamChoice, propEvent) {
        const { BetSlipStore, web3Store, originalEvent } = this.props;

        let bytes32_id = propEvent.bytes32Id;
        let event_id = propEvent._id
        let start_time = propEvent.startTime;
        let team_one = originalEvent.teams[0];
        let team_two = originalEvent.teams[1];
        let duration = propEvent.duration;

        // let team_one = this.state.teamOneName;
        // let team_two = this.state.teamTwoName;

        let selectedTeam = "";
        if (teamChoice == 1) {
            selectedTeam = propEvent.teams[0];
        }
        if (teamChoice == 2) {
            selectedTeam = propEvent.teams[1];
        }
        if (teamChoice == 0) {
            selectedTeam = "Draw";
        }

        const wagerBytes32Id = web3Store.web3.utils.sha3(selectedTeam + event_id + teamChoice + (+Date.now()));
        console.log(wagerBytes32Id)
        BetSlipStore.WagerList.add({
            bytes32Id: wagerBytes32Id,
            eventId: event_id,
            eventBytes32Id: bytes32_id,
            maker: web3Store.account,
            value: 50000000000000000,
            odds: 100,
            makerChoice: teamChoice,
            settled: false,
            cancelled: false,
            selectedTeam: selectedTeam,
            team_one: team_one,
            team_two: team_two,
            eventStartTime: start_time,
            eventDuration: duration,
            isPropWager: true,
            originalEventId: originalEvent._id
        });
    }

    openModal() {
        this.setState({ modalVisible: true });
    }

    handleNewBetTitleChange(e) {
        this.setState({ newBetTitle: e.target.value })
    }

    handleNewBetOptionOneChange(e) {
        const web3 = this.props.web3Store.web3;
        this.setState({
            newBetOptionOne: e.target.value,
            optionOneBytesId: web3.utils.padRight(web3.utils.fromAscii(e.target.value.slice(0, 17)), 34)
        })
    }

    handleNewBetOptionTwoChange(e) {

        const web3 = this.props.web3Store.web3;
        console.log(web3.utils.padRight(web3.utils.fromAscii(e.target.value.slice(0, 17)), 34));
        this.setState({
            newBetOptionTwo: e.target.value,
            optionTwoBytesId: web3.utils.padRight(web3.utils.fromAscii(e.target.value.slice(0, 17)), 34)
        })
    }

    handleNewBetDuration(e) {
        console.log("bet duration " + e);
        this.setState({ newBetDuration: Number(e) })

    }

    onDrawPossibleChange(e) {
        console.log("draw possible " + !this.state.drawPossible);
        this.setState({ drawPossible: !this.state.drawPossible })
    }

    handleDateChange(moment, dateString) {
        let date = (moment ? moment.toDate() : null);
        //this.setState({ startDate: date });

        if (date != null) {
            this.setState({ officialStart: date.getTime() / 1000 });
            console.log("official start: " + this.state.officialStart);
        }
    }


    render() {
        const { UserStore } = this.props;

        const newBetModal = <Modal
            isOpen={this.state.modalVisible}
            onRequestClose={this.handleModalCancel}
            className="custom-bet-modal"
            overlayClassName="custom-bet-modal-overlay"
        >

            <div className="admin-form-field">
                <div className="admin-form-field-title">Title: </div>
                <input
                    type="text"
                    className="custom-input"
                    style={{ width: '60%' }}
                    placeholder="What will be the result of the coin toss"
                    value={this.state.newBetTitle}
                    onChange={this.handleNewBetTitleChange}
                />
            </div>


            <div className="admin-form-field">
                <div className="admin-form-field-title">Option One: </div>
                <input
                    type="text"
                    className="custom-input"
                    style={{ width: '60%' }}
                    placeholder="Heads"
                    value={this.state.newBetOptionOne}
                    onChange={this.handleNewBetOptionOneChange}
                />
            </div>

            <div className="admin-form-field">
                <div className="admin-form-field-title">Option Two: </div>
                <input
                    type="text"
                    className="custom-input"
                    style={{ width: '60%' }}
                    placeholder="Tails"
                    value={this.state.newBetOptionTwo}
                    onChange={this.handleNewBetOptionTwoChange}
                />
            </div>


            <div className="admin-form-field-title">Duration (seconds): </div>
            <InputNumber theme="dark" onChange={this.handleNewBetDuration} />
            <p>{this.state.newBetDuration}</p>

            <h2>Start Date and Time</h2>
            <DatePicker showTime onChange={this.handleDateChange} />
            {/* <TimePicker onChange={this.handleTimeChange}/> */}
            <p>Start time is: {new Date(this.state.officialStart * 1000).toDateString()} {new Date(this.state.officialStart * 1000).toLocaleTimeString()} in your local time zone</p>
            <br />

            {/* <h2>Draw Possible</h2>
            <Checkbox onChange={this.onDrawPossibleChange} />
            <br /> */}



            <br />
            <br />
            <button onClick={this.handleModalCancel} className="custom-btn-danger">Exit</button>
            <button onClick={this.handleModalOk} className="custom-btn-success">Submit</button>
        </Modal>


        return (<div style={{position:'relative', top: "-400px"}}>
            <br />
            {newBetModal}
            {(UserStore.user.role === "admin" ? <button onClick={this.openModal} className="custon-btn-primary">Add Bet Type</button> : null)}
            {/* <div className="single-event-page-card-wagers-title">Prop Bets</div> */}
            <br />
            {this.state.finalRender}
        </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/layoutComponents/PropBets.js